<template>
	<div v-show="isModalVisible">
		<transition name="slide">
			<div class="modal-mask" @click="hide">
				<div class="modal-dialog modal-dialog-slideout modal-lg"  @click.stop>
					<div class="modal-content  p-0">

						<div class="modal-header">
						</div>                
							
						<div class="modal-body" style="height: calc(100vh - 140px);">
							<div class="mm-ask">
								<div class="mm-ask-head">
									<span :class="updateMmAskBadge"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-compass h-4 w-4" aria-hidden="true"><path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z"></path><circle cx="12" cy="12" r="10"></circle></svg></span>
									<div class="mm-ask-heading">
										<p class="mm-ask-title">Ask</p>
										<p class="mm-ask-sub">{{ subtitle }}</p>
									</div>
									<button @click="hide()" type="button" style="right: 25px;position: absolute;top: 0px; border: 0; background: none;" class="absolute right-6 top-5 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x h-4 w-4" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg><span class="sr-only">Close</span></button>
								</div>

								<div v-if="lastQuestion" class="mm-ask-thread">
									<button type="button" class="mm-ask-back" @click="clearThread" :disabled="loading">
										← Back to suggestions
									</button>
									<div class="mm-ask-question">
										<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mm-ask-question-icon"><polyline points="15 10 20 15 15 20"></polyline><path d="M4 4v7a4 4 0 0 0 4 4h12"></path></svg>
										<span>{{ lastQuestion }}</span>
									</div>
									<div v-if="loading" class="mm-ask-loading">Thinking…</div>
									<AskResponseCard
										v-else-if="currentResponse"
										:response="currentResponse"
										:role-accent="roleAccent"
										:feedback-sent="feedbackSent"
										@action="onAction"
										@wrong-answer="reportWrongAnswer"
									/>
								</div>

								<div v-else class="flex-1 overflow-y-auto">
									<p class="mm-ask-label">Suggested questions</p>
									<div class="mm-ask-prompts">
										<button
											v-for="p in prompts"
											:key="p"
											type="button"
											class="mm-ask-prompt"
											:disabled="loading"
											@click="ask(p)"
										>
											<span>{{ p }}</span>
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 7h10v10"></path><path d="M7 17 17 7"></path></svg>
										</button>
									</div>
								</div>
              </div>
              <div class="mm-ask-disclaimer col-12">AI-generated. Verify important numbers before acting.</div>
              <form class="mm-ask-input m-0" @submit.prevent="submit" style="position: absolute; z-index: 99999; bottom: 0px; left: 0;  right: 0; bottom: 0;">
                <div class="flex mx-3 ml-4 mr-4 items-center gap-2 rounded-xl border bg-background px-3 py-1.5 focus-within:ring-1 focus-within:ring-ring" style="width: 100%;">
                <input
                  v-model="query"
                  type="text"
                  name="askInput"
                  id="askInput"
                  class="mm-ask-field"
                  placeholder="Ask your own question…"
                  ref="askInput"
                  :disabled="loading"
                />
                <button
                  type="submit"
                  :class="updateMmAskSend"
                  :disabled="loading || !query.trim()"
                  aria-label="Send"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-corner-down-left h-3.5 w-3.5" aria-hidden="true"><path d="M20 4v7a4 4 0 0 1-4 4H4"></path><path d="m9 10-5 5 5 5"></path></svg>
                </button>
                </div>
              </form>

						</div>
						<div class="modal-footer mb-5"></div>
					</div>
				</div>
			</div>
		</transition>

  
  </div>

</template>
<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { BPopover } from 'bootstrap-vue'
Vue.component('b-popover', BPopover)

import router from '../../router/index.js';
import AskResponseCard from "./AskResponseCard.vue";
import {
  SUGGESTED_PROMPTS,
  ROLE_SUBTITLE,
  ROLE_ACCENT,
} from "./askResponders";


export default {
		props: {
			role: { type: String, default: "manager" },
			isModalVisible: { type: Boolean, default: false },
			accountId: { type: [Number, String], default: null },
      location: { type: Array, default: () => []},
      menteeNames: { type: Array, default: () => []},
      tasks:  { type: Array, default: () => []},
		},
    data() {
			return {
				loading: false,
				query: "",
				lastQuestion: "",
				currentResponse: null,
				feedbackSent: false,
        prompts: []
			}
    },
    components: {
			AskResponseCard,
    },
		computed: {
      updateMmAskBadge() {
        if (this.role == 'mentor') {
          return 'mm-ask-badge-mentor';
        }
        else if (this.role == 'manager') {
          return 'mm-ask-badge-manager'
        }
        else {
          return 'mm-ask-badge';
        }
      },
      updateMmAskSend() {
        if (this.role == 'mentor') {
          return 'mm-ask-send-mentor';
        }
        else if (this.role == 'manager') {
          return 'mm-ask-send-manager'
        }
        else {
          return 'mm-ask-send';
        }
      },
			subtitle() {
				return ROLE_SUBTITLE[this.role] || ROLE_SUBTITLE.manager;
			},
			roleAccent() {
				return ROLE_ACCENT[this.role] || "#00ACEE";
			},
			resolvedAccountId() {
				if (this.accountId != null && this.accountId !== '') {
					return this.accountId;
				}
				return this.$store && this.$store.state ? this.$store.state.user_accountid : null;
			},
		},
		watch: {
			isModalVisible(val) {
				if (!val) {
					this.clearThread();
					this.query = "";
				}
			},
		},
    methods: {       
			hide() { 
				this.$emit('close');
			},
			clearThread() {
				this.currentResponse = null;
				this.lastQuestion = "";
        this.generatePrompts();
				this.loading = false;
				this.feedbackSent = false;
			},
			ask(text) {
				const q = String(text || "").trim();
				if (!q || this.loading) return;
				this.lastQuestion = q;
				this.currentResponse = null;
				this.feedbackSent = false;
				this.query = "";
				this.loading = true;

				axios.post('/desktop/nova/chat', {
					question: q,
					role: this.role,
					accountId: this.resolvedAccountId,
				})
				.then((resp) => {
					const data = resp.data || {};
					this.currentResponse = {
						kind: data.kind || 'status',
						text: data.text || 'No answer returned.',
						action: data.action || null,
						actions: Array.isArray(data.actions) ? data.actions : null,
						eyebrow: data.eyebrow,
					};
				})
				.catch(() => {
					this.currentResponse = {
						kind: 'redirect',
						eyebrow: 'Unavailable',
						text: 'I could not reach Ask right now. Please try again in a moment.',
					};
				})
				.finally(() => {
					this.loading = false;
          this.$nextTick(() => {
              setTimeout(() => {
                  this.$refs.askInput.focus();
              }, 100);
          });
				});
			},
			submit() {
				this.ask(this.query);
			},
			reportWrongAnswer() {
				if (!this.currentResponse || this.feedbackSent) return;
				this.feedbackSent = true;
				axios.post('/desktop/nova/feedback', {
					question: this.lastQuestion,
					answerText: this.currentResponse.text,
					answerKind: this.currentResponse.kind,
					eyebrow: this.currentResponse.eyebrow,
					action: this.currentResponse.action,
					actions: this.currentResponse.actions,
					role: this.role,
					accountId: this.resolvedAccountId,
				}).catch(() => {
					// Keep UI confirmation even if logging fails; avoid noisy retries.
				});
			},
			onAction(action) {
				const eventName = action && action.event ? action.event : '';
				if (eventName === 'open-my-profile') {
					this.hide();
					router.push('/myprofile');
					return;
				}
				if (eventName === 'open-admin' || eventName === 'open-admin-console') {
					this.hide();
					router.push('/admin-console');
					return;
				}
				if (eventName === 'open-review-queue' || eventName === 'open-reps-to-review') {
					this.hide();
					this.$emit('action', action);
					return;
				}
				if (eventName === 'open-add-rep') {
					this.hide();
					this.$emit('action', action);
					return;
				}
				this.$emit('action', action);
			},
      randomLocation() {
        if (!this.location.length) {
          return "your location";
        }
        const index = Math.floor(Math.random() * this.location.length);
        return this.location[index].locationName;
      },
      randomMentees() {
        if (!this.menteeNames.length) {
          return "your mentee";
        }
        const index = Math.floor(Math.random() * this.menteeNames.length);
        return this.menteeNames[index].name;
      },
      randomTasks() {
        if (!this.tasks.length) {
          return "your task";
        }
        const index = Math.floor(Math.random() * this.tasks.length);
        return this.tasks[index].name;
      },
      getRandomPrompts(count = 2) {
        const templates =
          SUGGESTED_PROMPTS[this.role] || SUGGESTED_PROMPTS.manager;

        const available = [...templates];
        const selected = [];

        while (selected.length < count && available.length) {
          const index = Math.floor(Math.random() * available.length);
          selected.push(available.splice(index, 1)[0]);
        }

        return selected;
      },
      generatePrompts() {
        this.prompts = this.getRandomPrompts(6).map(prompt => {
        return prompt
          .replace("{location}", this.randomLocation())
          .replace("{mentee1}", this.randomMentees())
          .replace("{mentee2}", this.randomMentees())
          .replace("{mentee3}", this.randomMentees())
          .replace("{mentee4}", this.randomMentees())
          .replace("{mentee5}", this.randomMentees())
          .replace("{mentee6}", this.randomMentees())
          .replace("{skill}", this.randomTasks())
          .replace("{skill1}", this.randomTasks())
          .replace("{reward}", 'Competency')
        });
      },
			loadInitialData() {
        this.generatePrompts();
			},
    },
    created() {

    }   
}
</script>
<style scoped>
.back_icon { width: 14px; }
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.rounded {
    border-radius: 10px !important;
    padding: 20px;
    border: 1px solid #B8B7B8;
}
.seat_qty {
    font-size: 13px;
}
.receipt-heading {
  float: left;
  font-weight: normal;
  font-size: 14px;
  text-decoration: underline;
}
.receipt-heading-1{
  width: 18%;
}
.receipt-heading-4 {
  width: 22%;
  text-align: right;
}
.receipt-heading-3 {
  width: 30%; 
}
.receipt-heading-6 {
  width: 12%; 
}
.receipt-heading-2 {
  width: 18%;
}
.receipt-heading-1-1 {
  width: 15%;
}
.receipt-heading-6-1 {
  width: 18%;
}
.receipt-heading-2-1 {
  width: 15%;
}
.receipt-heading-3-1 {
  width: 22%; 
}
.receipt-heading-4-1 {
  width: 18%;
  text-align: right;
}
.receipt {
  font-weight: normal;
  text-decoration: none;
  float: left;
  font-size: 13px;
  padding-top: 8px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;

}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;

}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #808080;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 2px;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #FFF;
}

input:checked + .slider {
  background-color: #4E8D23;
}
input:checked + .slider:before {
  background-color: #FFF;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.mm-ask {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.mm-ask-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-right: 28px;
}
.mm-ask-badge {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 172, 238, 0.1);
  color: #00acee;
  flex: 0 0 auto;
}
.mm-ask-badge-mentor {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(121, 94, 255, 0.1);
  color: #795eff;
  flex: 0 0 auto;
}
.mm-ask-badge-manager {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 145, 24, 0.1);
  color: #009118;
  flex: 0 0 auto;
}
.mm-ask-heading {
  min-width: 0;
}
.mm-ask-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #002f42;
}
.mm-ask-sub {
  margin: 2px 0 0;
  font-size: 13px;
  color: #6b7785;
}
.mm-ask-thread {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mm-ask-back {
  align-self: flex-start;
  border: none;
  background: none;
  padding: 0;
  margin: 0 0 4px;
  font-size: 13px;
  color: #00acee;
  cursor: pointer;
}
.mm-ask-back:hover:not(:disabled) {
  text-decoration: underline;
}
.mm-ask-back:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.mm-ask-question {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  align-self: flex-end;
  max-width: 90%;
  padding: 8px 12px;
  border-radius: 12px 12px 2px 12px;
  background: #eef4f7;
  font-size: 13px;
  color: #002f42;
}
.mm-ask-question-icon {
  color: #8a99a2;
  margin-top: 2px;
  flex: 0 0 auto;
}
.mm-ask-loading {
  padding: 14px 16px;
  border: 1px solid #e4e9ec;
  border-radius: 12px;
  font-size: 14px;
  color: #6b7785;
  background: #fff;
}
.mm-ask-prompt:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.mm-ask-label {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #9aa6ae;
}
.mm-ask-prompts {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.mm-ask-prompt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  text-align: left;
  padding: 11px 14px;
  border-radius: 10px;
  border: 1px solid #e4e9ec;
  background: #fff;
  color: #002f42;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.mm-ask-prompt:hover {
  background-color: rgba(0, 172, 238, 0.07);
  border-color: transparent;
}
.mm-ask-prompt-icon {
  color: #00acee;
  flex: 0 0 auto;
}
.mm-ask-input {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
  border-top: 1px solid #e4e9ec;
  padding-top: 20px;
}
.mm-ask-disclaimer {
  margin: 0 1rem;
  font-size: 11px;
  color: #9aa6ae;
  line-height: 1.3;
  text-align: center;
  position: absolute;
  z-index: 999999;
  bottom: 70px;
  left: 0px;
  right: 0px;
}
.mm-ask-field {
  flex: 1;
  height: 30px;
  padding: 0 14px;
  border-radius: 10px;
  border: 0px solid #e4e9ec;
  font-size: 14px;
  color: #002f42;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.mm-ask-field::placeholder {
  color: #9aa6ae;
}
.mm-ask-field:focus {
  border-color: #00acee;
  box-shadow: 0 0 0 3px rgba(0, 172, 238, 0.15);
}
.mm-ask-send {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 10px;
	background: #00ACEE;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease;
}
.mm-ask-send:hover:not(:disabled) {
  background: #00ACEE;
}
.mm-ask-send:disabled {
  background: #00ACEE;
  cursor: not-allowed;
	opacity: 40%;
}
.mm-ask-send-mentor {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 10px;
	background: #795eff;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease;
}
.mm-ask-send-mentor:hover:not(:disabled) {
  background: #795eff;
}
.mm-ask-send-mentor:disabled {
  background: #795eff;
  cursor: not-allowed;
	opacity: 40%;
}
.mm-ask-send-manager {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 10px;
	background: #009118;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease;
}
.mm-ask-send-manager:hover:not(:disabled) {
  background: #009118;
}
.mm-ask-send-manager:disabled {
  background: #009118;
  cursor: not-allowed;
	opacity: 40%;
}

.py-1\.5 {
    padding-block: calc(0.25rem * 1.5);
}
.px-3 {
    padding-inline: calc(0.25rem * 3);
}
.bg-background {
    background-color: #FFF;
}
.border {
    border-width: 1px;
}
.rounded-xl {
    border-radius: calc(0.625rem + 4px);
}
.flex {
    display: flex;
}
.overflow-y-auto {
    overflow-y: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/manager/ask_panel_modal.vue